import React from "react";
import { motion } from "framer-motion";
import { ClipboardList, CreditCard, MapPin, AlertTriangle } from "lucide-react";
import { fadeUp } from "@/lib/motion-presets";

const Steps = [
  { num: "01", icon: <ClipboardList size={20} />, title: "Submit your pre-order", desc: "Browse the menu, build your plate, and send through the cart." },
  { num: "02", icon: <CreditCard size={20} />, title: "Send your payment", desc: "Pay with card via Stripe, or send to $deekenros on Cash App, Zelle, or Apple Pay." },
  { num: "03", icon: <MapPin size={20} />, title: "Receive confirmation", desc: "Pickup location is shared by text once payment is confirmed." },
];

const HowToOrder = () => {
  return (
    <section id="how" className="relative py-24 sm:py-32 story-bg" data-testid="how-to-order-section">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-8">
        <div className="mb-16 max-w-3xl">
          <div className="eyebrow mb-4">The Process</div>
          <h2 className="font-display text-5xl sm:text-7xl leading-none tracking-tighter">
            How to <span className="italic" style={{ color: "var(--awd-ochre)" }}>order</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16">
          {Steps.map((s, i) => (
            <motion.div
              key={s.num}
              {...fadeUp}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              className="p-8 border h-full flex flex-col"
              style={{ borderColor: "var(--awd-border-2)", background: "rgba(15,13,12,0.7)" }}
              data-testid={`step-${s.num}`}
            >
              <div className="flex items-start justify-between mb-6">
                <div className="font-display text-6xl" style={{ color: "var(--awd-jollof)" }}>{s.num}</div>
                <div className="p-2.5" style={{ color: "var(--awd-ochre)", border: "1px solid var(--awd-border-2)" }}>{s.icon}</div>
              </div>
              <h3 className="font-display text-2xl mb-3">{s.title}</h3>
              <p className="text-sm" style={{ color: "var(--awd-text-2)" }}>{s.desc}</p>
            </motion.div>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="p-6 border" style={{ borderColor: "var(--awd-border)" }} data-testid="window-open">
            <div className="label-mini mb-2">Orders Open</div>
            <div className="font-display text-3xl">Monday</div>
          </div>
          <div className="p-6 border" style={{ borderColor: "var(--awd-border)" }} data-testid="window-close">
            <div className="label-mini mb-2">Orders Close</div>
            <div className="font-display text-3xl">Thursday <span className="text-base italic" style={{ color: "var(--awd-text-3)" }}>(or sold out)</span></div>
          </div>
          <div className="p-6 border flex items-start gap-3" style={{ borderColor: "var(--awd-jollof)", background: "rgba(155,34,38,0.08)" }}>
            <AlertTriangle size={20} style={{ color: "var(--awd-jollof)" }} className="mt-0.5" />
            <div>
              <div className="label-mini mb-1" style={{ color: "var(--awd-jollof)" }}>House Rules</div>
              <div className="text-sm" style={{ color: "var(--awd-text-2)" }}>No late orders. No walk-ins. No pay-at-pickup. Orders confirmed only after payment is received.</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowToOrder;
